import { MC, waitForEvent, playSound, stopAllSounds, asyncTween } from "../../../animate/utils";
import { BaseGame } from "./BaseGame";
export default class Game18 extends BaseGame {
    helpBtn: any;
    initGame = async (game: MC, gameEnd: () => void, helpBtn: any) => {
        this.helpBtn = helpBtn;
        game.visible = true;
        game.alpha = 0;
        game.mouseChildren = false;
        await asyncTween(game, { alpha: 1 }, 300);
        if (!this.shouldPlay) return;
        game.gotoAndPlay(1);
        await waitForEvent(game, "questionEnd");
        if (!this.shouldPlay) return;
        helpBtn(false);
        game.gotoAndStop(136);
        this.addEventToBtn(game, gameEnd, game.maya_btn);
        this.addEventToBtn(game, gameEnd, game.meter_btn);
        game.mouseChildren = true;
    };
    addEventToBtn = (game: MC, gameEnd: () => void, currentBtn: MC) => {
        currentBtn.gotoAndStop(0);
        currentBtn.cursor = "pointer";
        currentBtn.addEventListener("click", async () => {
            this.checkIfCorrectAnswer(game, gameEnd, currentBtn);
        });
        currentBtn.addEventListener("rollover", async () => {
            currentBtn.gotoAndStop(2);
        });
        currentBtn.addEventListener("rollout", async () => {
            currentBtn.gotoAndStop(0);
        });
    };
    checkIfCorrectAnswer = async (game: MC, gameEnd: () => void, currentBtn: MC) => {
        if (currentBtn.name === "maya_btn") {
            this.helpBtn(true);
            game.gotoAndPlay(174);
            await waitForEvent(game, "gameEnd");
            if (!this.shouldPlay) return;
            stopAllSounds();
            gameEnd();
        } else {
            await playSound("wrong");
            if (!this.shouldPlay) return;
        }
    };
}
